export default __webpack_public_path__ + "static/media/passengers.aac00525.png";